import { render, staticRenderFns } from "./PartnerEntitiesPrograms.vue?vue&type=template&id=7783fd19&scoped=true"
import script from "./PartnerEntitiesPrograms.vue?vue&type=script&lang=js"
export * from "./PartnerEntitiesPrograms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7783fd19",
  null
  
)

export default component.exports